import { css } from "styled-components";
import AlertCircle from "@insite/mobius/Icons/AlertCircle";
import AlertOctagon from "@insite/mobius/Icons/AlertOctagon";
import AlertTriangle from "@insite/mobius/Icons/AlertTriangle";
import Icon from "@insite/mobius/Icon";
import React from "react";
import Typography from "@insite/mobius/Typography";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";

// The `WidgetProps` interface provides a lot of information,
// including the CMS field values. The props object for a widget
// should always extend this interface.
interface OwnProps extends WidgetProps {
    // The values of the CMS fields are passed to the widget
    // in a `Dictionary` named "fields". You can statically type
    // the names of the fields to make access easier. This also
    // allows the TypeScript compiler to give you type-checking.
    fields: {
        noteText: string;
        noteIcon: string;
    };
}

type Props = OwnProps;

const CMSFieldsWidget = (props: Props) => {
    let icon = AlertCircle;
    if (props.fields.noteIcon === "AlertOctagon") {
        icon = AlertOctagon;
    } else if (props.fields.noteIcon === "AlertTriangle") {
        icon = AlertTriangle;
    }
    return (
        <div style={{ display: "flex", alignItems: "flex-start" }}>
            <Icon
                src={icon}
                css={css`
                    margin-right: 0.5em;
                `}
            />
            {/* Translatable field values will be translated based on the currently selected language for the site. */}
            <Typography>{props.fields.noteText}</Typography>
        </div>
    );
};

const widgetModule: WidgetModule = {
    component: CMSFieldsWidget,
    definition: {
        fieldDefinitions: [
            {
                name: "noteText",
                fieldType: "Translatable",
                // Spire provides quite a few editorTemplates out-of-the-box.
                editorTemplate: "TextField",
                defaultValue: "",
                isRequired: true,
            },
            {
                name: "noteIcon",
                fieldType: "General",
                editorTemplate: "DropDownField",
                defaultValue: "AlertCircle",
                options: [{ value: "AlertCircle" }, { value: "AlertOctagon" }, { value: "AlertTriangle" }],
                isRequired: true,
            },
        ],
        group: "Common",
    },
};

export default widgetModule;
